<script lang="ts">
  import { StaffPermissions } from "@models/permissions/StaffPermissions"
  import { put } from "@util/api"

  import BooleanCheckbox from "./ui/BooleanCheckbox.svelte"
  import Form from "./ui/Form.svelte"
  import RadioButton from "./ui/RadioButton.svelte"
  import RadioButtons from "./ui/RadioButtons.svelte"

  export let path: string
  export let staffPermissions: StaffPermissions
  export let userCanEdit: boolean
  export let teamManagementEnabled: boolean

  let disabled = !userCanEdit
  let myTripsDisabled = !userCanEdit || !teamManagementEnabled

  function validate() {
    return {}
  }

  function submit() {
    return put(path, { staffPermissions })
  }
</script>

<Form data={staffPermissions} {submit} {validate} let:submitting let:submitted let:errors on:change={submit}>
  <div class="divide-y">
    <!-- These will be uncommented as we add more functionality. They've been QA'd and they do work.
    <div class="grid md:grid-cols-3 items-center justify-start gap-inline-4 text-sm">
      <div class="mt-4 sm:mt-0">Viewable Trips</div>
      <div class="md:col-span-2">
        <RadioButtons>
          <RadioButton name="viewTrips" bind:group={staffPermissions.viewTrips} value="no_trips" {disabled}>No Trips</RadioButton>
          <RadioButton name="viewTrips" bind:group={staffPermissions.viewTrips} value="my_trips" disabled={myTripsDisabled}
            >Assigned Trips</RadioButton
          >
          <RadioButton name="viewTrips" bind:group={staffPermissions.viewTrips} value="all_trips" {disabled}
            >All Trips</RadioButton
          >
        </RadioButtons>
      </div>
    </div>

    <div class="grid md:grid-cols-3 items-center justify-start gap-inline-4 text-sm">
      <div class="mt-4 sm:mt-0">Passengers Editable For</div>

      <div class="md:col-span-2">
        <RadioButtons>
          <RadioButton name="editPassengers" bind:group={staffPermissions.editPassengers} value="no_trips" {disabled}
            >No Trips</RadioButton
          >
          <RadioButton
            name="editPassengers"
            bind:group={staffPermissions.editPassengers}
            value="my_trips"
            disabled={myTripsDisabled}>Assigned Trips</RadioButton
          >
          <RadioButton name="editPassengers" bind:group={staffPermissions.editPassengers} value="all_trips" {disabled}
            >All Trips</RadioButton
          >
        </RadioButtons>
      </div>
    </div>

    <div class="grid md:grid-cols-3 items-center justify-start gap-inline-4 text-sm">
      <div class="mt-4 sm:mt-0">Trip Financials Viewable For</div>

      <div class="md:col-span-2">
        <RadioButtons>
          <RadioButton name="viewTripFinancials" bind:group={staffPermissions.viewTripFinancials} value="no_trips" {disabled}
            >No Trips</RadioButton
          >
          <RadioButton
            name="viewTripFinancials"
            bind:group={staffPermissions.viewTripFinancials}
            value="my_trips"
            disabled={myTripsDisabled}>Assigned Trips</RadioButton
          >
          <RadioButton name="viewTripFinancials" bind:group={staffPermissions.viewTripFinancials} value="all_trips" {disabled}
            >All Trips</RadioButton
          >
        </RadioButtons>
      </div>
    </div>
  -->

    <div class="grid md:grid-flow-col items-center justify-start gap-inline-8 text-sm col-span-2 mt-4 sm:mt-0">
      <BooleanCheckbox
        label="Can Edit Trips"
        name="editTrips"
        dataRole="edit-trips"
        bind:value={staffPermissions.editTrips}
        {disabled} />
      <BooleanCheckbox
        label="Can Edit Teams"
        name="editTeams"
        dataRole="edit-teams"
        bind:value={staffPermissions.editTeams}
        {disabled} />
      <BooleanCheckbox
        label="Can Edit Permissions"
        name="editPermissions"
        dataRole="edit-permissions"
        bind:value={staffPermissions.editPermissions}
        {disabled} />
      <BooleanCheckbox
        label="Can View Company Financials"
        name="viewCompanyFinancials"
        dataRole="view-company-financials"
        bind:value={staffPermissions.viewCompanyFinancials}
        {disabled} />
      <BooleanCheckbox
        label="Can Edit Company Settings"
        name="editBusinessSettings"
        dataRole="edit-company-settings"
        bind:value={staffPermissions.editBusinessSettings}
        {disabled} />
    </div>
  </div>
</Form>
